const state = {
 add_job_rate_modal: false,
 current_order_job_id: null,
 current_rates: null,
 order_type: null,
 recruitment_margin_perc: null,
 reload_job_rates: false,
};

const actions = {};

const mutations = {
 SHOW_ADD_JOB_RATE_MODAL(state, payload) {
  state.add_job_rate_modal = true;
  state.current_order_job_id = payload.current_order_job_id;
  state.current_rates = payload.current_rates;
  state.order_type = payload.order_type;
  state.recruitment_margin_perc = payload.recruitment_margin_perc;
 },
 HIDE_JOB_RATE_MODAL(state) {
  state.add_job_rate_modal = false;
  state.current_order_job_id = null;
  state.current_rates = null;
  state.order_type = null;
  state.recruitment_margin_perc = null;
 },
 RELOAD_JOB_RATES(state, payload) {
  state.reload_job_rates = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
